import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "open-gallery",
  "use": "open-gallery-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 33\" id=\"open-gallery\"><path d=\"M-.04 19.5h4V29h9.5v4H-.04V19.5zm33 0V33h-13.5v-4h9.5v-9.5h4zm0-6h-4V4h-9.5V0h13.5v13.5zM13.46 0v4h-9.5v9.5h-4V0h13.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol